export default __webpack_public_path__ + "static/media/poll.7447080e.svg";